require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-rosetta-code-convert-seconds-to-compound-duration.json") })
        }
      }, "path---coding-interview-prep-rosetta-code-convert-seconds-to-compound-duration");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-rosetta-code-convert-seconds-to-compound-duration!./.cache/json/coding-interview-prep-rosetta-code-convert-seconds-to-compound-duration.json
// module id = 1856
// module chunks = 231608221292675